import { render, staticRenderFns } from "./GameSearch.vue?vue&type=template&id=4663cd6a&"
import script from "./GameSearch.vue?vue&type=script&lang=js&"
export * from "./GameSearch.vue?vue&type=script&lang=js&"
import style0 from "./GameSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4663cd6a')) {
      api.createRecord('4663cd6a', component.options)
    } else {
      api.reload('4663cd6a', component.options)
    }
    module.hot.accept("./GameSearch.vue?vue&type=template&id=4663cd6a&", function () {
      api.rerender('4663cd6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameSearch.vue"
export default component.exports